module.exports = __webpack_public_path__ + "media/fonts/TTCommons-Regular-66f23645ab4316014dc9ed2c04c10395.svg";